module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAARBJREFUOE/dlD1SAkEQhd8baqE4AosH2NXMCyiRiWbiDTwH7DE8gVVSRhwAMxNSYMt80dwIFvdZUIuOFLo/rokTTc90fdPdr6cJa7WW/ojAqX2WtZ/XZ7R9vhh/Bkze1MmKzNQ4WvvkinANfGmGDz9B3aWvfwQE1f9IN9lJ3KS2uPHJVcMsQez78kAxANXbfawcUHgCdAuyGqCAa0oHlQBJ3kfO9NJdeJ9CGXMM6aKMKK+kziInfNzWzo29HlKFiwOlYAuaN8J+e+WdK+Hw9ypLgVPnTbzCGIJbCRBW3aoB7mmZ4jXM8WX2NnZ7cdgVkiORJ0UnNlLhCDOJGtPBZmK3Yv+OQjdHQN+6iBg8O7Ord0nArBVKAMaGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/cathode_gre.png
// module id = 2R59
// module chunks = 2